import { targetDeliveryGenband20Template } from './target-delivery-genband-20-template';
import targetDeliveryUtimacoAramcoTemplate from './target-delivery-utimaco-aramco';
import targetDeliveryTemplateEricssonNE from './target-delivery-ericsson-ne-template';
import targetDeliveryRibbonC20CSCTemplate from './target-delivery-ribbon-c20-csc-template';

export const targetTemplates = {
  [targetDeliveryGenband20Template.key]: targetDeliveryGenband20Template,
  [targetDeliveryUtimacoAramcoTemplate.key]: targetDeliveryUtimacoAramcoTemplate,
  [targetDeliveryTemplateEricssonNE.key]: targetDeliveryTemplateEricssonNE,
  [targetDeliveryRibbonC20CSCTemplate.key]: targetDeliveryRibbonC20CSCTemplate
};

export default targetTemplates;
